module.exports = __webpack_public_path__ + "images/icons/flags/GR-0df6a356.svg";